import { ChangeEvent, FormEvent, MouseEvent, SyntheticEvent, ChangeEventHandler } from 'react'
import { TextAreaProps, InputOnChangeData, ButtonProps, DropdownProps, CheckboxProps } from 'semantic-ui-react'

export type EventType =
	| FormEvent<HTMLTextAreaElement>
	| ChangeEvent<HTMLInputElement>
	| SyntheticEvent<HTMLElement, Event>
	| ChangeEventHandler<HTMLSelectElement>
export type MouseType = MouseEvent<HTMLButtonElement>
export type DataType = TextAreaProps | InputOnChangeData | ButtonProps | DropdownProps | CheckboxProps
export type FormFieldType = {
	header: string
	section: number
	subHeader?: string
	fields: {
		key: string
		label: string
		value: null | string | number
		options?: string[]
		mandatory?: boolean
	}[]
	createdAt?: string
	lastUpdatedAt?: string
	userDetailsSet?: boolean
}

export type FormDataFields = {
	key: string
	label: string
	value: null | string | number
	options?: string[]
	mandatory?: boolean
}[]

export type FormDataField = {
	key: string
	label: string
	value: null | string | number
	options?: string[]
	mandatory?: boolean
}

export type FormData = {
	header: string
	key: string
	fields: FormDataFields
}[]
export type InitialStateType = {
	fnolForm: FormFieldType
	edit: boolean
	saveProgress: boolean
	fnolFormWithUserDetails: [] | FormFieldType[]
	postUserDetails: boolean
}

export type UserDetailsType = {
	id: string
}

export type SetEditAction = {
	type: 'SET_EDIT'
}

export type SetFormStateAction = {
	type: 'SET_FORM_STATE'
	payload: { response: FormFieldType }
}

export type UpdateFormStateAction = {
	type: 'UPDATE_FORM_STATE'
	payload: { sectionFormState: { [key: string]: string | number }; section: string; sectionNo: number }
}

export type SetUserDetailsAction = {
	type: 'SET_USER_DETAILS'
	payload: { userDetails: UserDetailsType; formSections: FormFieldType[] }
}

type SetFormDataAction = {
	type: 'SET_FORM_DATA'
	payload: FormData
}

export type FnolFormReducerActionsType =
	| SetEditAction
	| SetFormStateAction
	| UpdateFormStateAction
	| SetUserDetailsAction
	| SetFormDataAction
export type AccidentFetchResponse = {
	dataHeadings: {
		clientName: string
		customerName: string
		id: string
		policyNumber: string
		status: string
	}
	dataOptions: {
		[key: string]: {
			label: string
			values: { key: string; text: string; value: string }[]
		}
	}
	dataRows: {
		company: string
		name: string
		policyNumber: string
		reference: string
		registration: string
		status: string
		clientName: string
		customerAddress: string
	}[]
}

type Details = {
	valueId: number
	fieldId: number
	data: string
} | null

type ContactMethod = 'emailAddress' | 'phoneNumber'

export type ContactDetailsType = Record<ContactMethod, Details>

export type FnolFormPostData = {
	action: string
	formId?: string
	data: {
		header: string
		key: string
		fields: {
			key: string
			label: string
			mandatory: boolean
			value: string | null
			options?: string[]
		}[]
	}[]
}
